import React from "react";
const HexagonBadge = ({ children }) => {
  return (
    <div className="hexagon-container">
      <svg
        width="130"
        height="130"
        viewBox="-3 -3 136 136"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M65 2C66.5 2 68 2.4 69.3 3.2L118.9 29.2C121.6 30.8 123.2 33.6 123.2 36.7V93.3C123.2 96.4 121.6 99.2 118.9 100.8L69.3 126.8C68 127.6 66.5 128 65 128C63.5 128 62 127.6 60.7 126.8L11.1 100.8C8.4 99.2 6.8 96.4 6.8 93.3V36.7C6.8 33.6 8.4 30.8 11.1 29.2L60.7 3.2C62 2.4 63.5 2 65 2Z"
          stroke="#1A1A1A"
          strokeWidth="5"
          fill="white"
        />
        <path
          d="M65 2C66.5 2 68 2.4 69.3 3.2L118.9 29.2C121.6 30.8 123.2 33.6 123.2 36.7V48H6.8V36.7C6.8 33.6 8.4 30.8 11.1 29.2L60.7 3.2C62 2.4 63.5 2 65 2Z"
          fill="#1A1A1A"
        />
      </svg>
      <div className="hexagon-content">{children}</div>
    </div>
  );
};

export default HexagonBadge;
